/* eslint-disable no-unused-vars */
import { Controller } from 'react-hook-form';
import DateTimePicker from '../DateTimePicker';
import { getDateTimeFormats } from '../../../services/ukgDateTime';

/**
 * @param {import('rsuite/DatePicker').DatePickerProps & {
 * name: string; control: *; rules?: *, value?: []; hasError?: boolean}
 * } param0
 * */
const FormDateTimePicker = ({
    name,
    control,
    rules,
    value: unused,
    onChange: valueChanged,
    hasError,
    ...props
}) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
            field: {
                onChange, onBlur, value,
            },
        }) => (
            <DateTimePicker
                {...props}
                onClose={onBlur}
                value={value}
                onChange={(changedValue, event) => {
                    onChange(changedValue, event);
                    if (valueChanged) {
                        valueChanged(changedValue, event);
                    }
                }}
                onClean={onBlur}
                hasError={hasError}
            />
        )}
    />
);

export default FormDateTimePicker;
